import { Injectable } from '@angular/core';
import { CanActivate, Router, NavigationStart,RouterEvent, NavigationEnd, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../services/auth/auth.service'

@Injectable({
  providedIn: 'root'
})
export class NotAuthGuard implements CanActivate {
  private previousUrl;
  constructor(
    private authService:AuthService,
    private router: Router){

  }

  canActivate(next: ActivatedRouteSnapshot,state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.authService.currentUserValue().then(async (data) => {
      let currentUser = data;
      let url:any;
      if (!currentUser){
        return true;
      }else{
        url = await this.authService.getItem('currentUrl').then(data => data);
        this.router.navigateByUrl(url.value);
        return false;
      }
    });

  }


}
